import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Key = ({ children }) => (
  <kbd className="inline-grid place-items-center min-w-[18px] h-[18px] px-1 rounded border border-slate-200 bg-white font-sans text-[10px] font-semibold text-slate-500">
    {children}
  </kbd>
)

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || "")

const ShortcutsHint = ({ view, onGuide }) => (
  <div className="px-3 py-2.5 border-t border-slate-100 bg-slate-50/70 space-y-1.5 text-[11px] text-slate-500">
    <div className="flex items-center gap-1.5">
      <span className="grid place-items-center w-4 text-slate-400">⇢</span>
      {view === "people" ? I18n.t("project_planning.hints.drag_project") : I18n.t("project_planning.hints.drag_person")}
    </div>
    <div className="flex items-center gap-1.5"><Key>{isMac ? "⌥" : "Alt"}</Key>{I18n.t("project_planning.hints.duplicate")}</div>
    {view === "people" && <div className="flex items-center gap-1.5"><Key>⇧</Key>{I18n.t("project_planning.hints.range")}</div>}
    <div className="flex items-center gap-1.5"><Key>⇧</Key>{I18n.t("project_planning.hints.select")}</div>
    <button type="button" onClick={onGuide} className="flex items-center gap-1.5 pt-0.5 font-medium text-brand-600 hover:text-brand-700">
      <FontAwesomeIcon icon="lightbulb" className="w-4 text-[11px]" />
      {I18n.t("project_planning.guide.all_tips")}
    </button>
  </div>
)

export default ShortcutsHint
